export const TEST_ASSIGNMENT_TYPES = {
	CONTROL: 'control',
	SKIP_PLASTIC: 'variant1',
	SKIP_PLASTIC_WITH_BUTTON: 'variant2',
};

export const TEST_NAMES = {
	SKIP_PLASTIC: 'skip-plastic-test',
};
